import { useStore } from 'zustand';
import { useEditAreaDraftStore } from '@/entities/edit-area';

const DISCARD_CONFIRM = '적용하지 않은 입력을 버리고 선택을 바꾸시겠습니까?';

/** 인스펙터의 입력 중 표시 키 — 인쇄 영역 폼과 배치 위치 폼. */
const isInspectorInput = (key: string): boolean =>
  key === 'component' || key.startsWith('placement:');

export interface SelectArea {
  /**
   * 인쇄 영역을 고른다(빈 곳은 null). 인스펙터에 적용하지 않은 입력이 있으면 확인한 뒤 그 입력을 버린다.
   * 바꿨거나 이미 그 선택이면 true, 확인 창에서 그만두면 false.
   */
  readonly select: (componentId: string | null) => boolean;
  /** 인스펙터의 적용하지 않은 입력을 확인을 받아 버린다. 입력이 없거나 버렸으면 true. */
  readonly discardInspectorInputs: () => boolean;
}

/** 사진·목록·도구 줄이 함께 쓰는 선택 규칙. */
export const useSelectArea = (): SelectArea => {
  const state = useStore(useEditAreaDraftStore());
  const discardInspectorInputs = (): boolean => {
    const pending = Object.keys(state.pendingInputs).filter(isInspectorInput);
    if (pending.length > 0 && !window.confirm(DISCARD_CONFIRM)) return false;
    for (const key of pending) state.setInputDirty(key, false);
    return true;
  };
  const select = (componentId: string | null): boolean => {
    if (state.locked) return false;
    if (componentId === state.selection.componentId) return true;
    if (!discardInspectorInputs()) return false;
    state.setSelection({ componentId });
    return true;
  };
  return { select, discardInspectorInputs };
};
